@if (visible()) {
  <div class="layer-cycle-strip" data-consumes-wheel>
    @for (entry of entries(); track entry.pubkey) {
      <button
        type="button"
        class="entry"
        [class.active]="entry.active"
        [attr.aria-label]="entry.active ? 'Active layer (click to dismiss)' : 'Spotlight this layer'"
        [title]="entry.active ? 'click to dismiss' : ''"
        (click)="onEntryClick(entry)">
        <span class="dot" [style.background-color]="entry.color"
                          [style.box-shadow]="entry.active ? '0 0 14px ' + entry.color + ', 0 0 4px ' + entry.color : 'none'"></span>
      </button>
    }
  </div>
}
